import { Component, OnInit, OnDestroy } from "@angular/core";
import { first } from "rxjs/operators";
import { Subscription } from "rxjs";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import * as _ from "lodash";

import { AppGlobals } from "../app.globals";
import { StorageService, AdmissionsService, AuthenticationService, MediaWatcherService, LookupsService, AlertService } from "../_services";
import { IUser } from "../_models";
import { AdmissionsApplicationDialogComponent } from "./application";
import { AdmissionsApplicationDocumentsDialogComponent } from "./applicationDocuments";
import { ConfirmationDialogComponent } from "../_components/confirmationDialog/confirmationDialog.component";

@Component({
    templateUrl: "admissions.component.html",
    styleUrls: ["admissions.component.css"]
})
export class AdmissionsComponent implements OnInit, OnDestroy {
    applications = null;
    isMobile = false;

    currentUser: IUser;
    currentUserSubscription: Subscription;
    mediaWatcherSubscription: Subscription;

    allScholasticPeriods = [];

    displayedColumns = [];

    dataSource = this.applications;

    constructor(private admissionsService: AdmissionsService, private storageService: StorageService, private appGlobals: AppGlobals, private authenticationService: AuthenticationService,
        public dialog: MatDialog, private mediaWatcherService: MediaWatcherService, private lookupsService: LookupsService, private alertService: AlertService) {

    }

    ngOnInit() {
        this.appGlobals.pageTitleValue = "Admissions";

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;

            if (this.isMobile)
                this.displayedColumns = ["scholasticPeriodDescription", "additionalScholasticPeriodDescription", "admissionsApplicationTypeDescription", "admissionsApplicationStepDescription", "dateCreated", "lastUpdatedOn", "dateCompleted", "applicationStatus", /*"edit",*/ "view", "housing", "print", "documents"]; //, "dateCreated", "dateCompleted"];
            else
                this.displayedColumns = ["admissionsApplicationStatusId", "scholasticPeriodDescription", "additionalScholasticPeriodDescription", "admissionsApplicationTypeDescription", "admissionsApplicationStepDescription", "dateCreated", "lastUpdatedOn", "dateCompleted", "applicationStatus", /*"edit",*/ "view", "housing", "print", "documents"]; //, "dateCreated", "dateCompleted"];
        });

        this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;
        });

        //semesters
        this.lookupsService.getSemesters()
            .pipe(first())
            .subscribe((response: any) => {
                const semesters = response;

                //programs
                this.lookupsService.getPrograms()
                    .pipe(first())
                    .subscribe((response: any) => {
                        const programs = response;

                        _.forEach(semesters, (f: any) => {
                            const scholasticPeriod = {
                                id: this.allScholasticPeriods.length + 1,
                                scholasticPeriodId: f.id,
                                programId: null,
                                startDate: f.startDate,
                                endDate: f.endDate,
                                title: f.title,
                                schoolId: f.schoolId,
                                isActive: f.isActive,
                                isOpenForAdmissions: f.isOpenForAdmissions
                            };

                            this.allScholasticPeriods.push(scholasticPeriod);
                        });

                        _.forEach(programs, (f: any) => {
                            const scholasticPeriod = {
                                id: this.allScholasticPeriods.length + 1,
                                scholasticPeriodId: null,
                                programScholasticPeriodId: f.scholasticPeriodId,
                                programId: f.id,
                                startDate: f.startDate,
                                endDate: f.endDate,
                                title: f.description,
                                schoolId: f.schoolId,
                                isActive: f.isActive,
                                isOpenForAdmissions: f.isOpenForAdmissions
                            };

                            this.allScholasticPeriods.push(scholasticPeriod);
                        });

                        this.getApplications();
                    });
            });
    }

    getApplications() {
        if (this.currentUser) {
            this.admissionsService.getApplications(this.currentUser.id)
                .pipe(first())
                .subscribe(
                    result => {
                        let today = new Date();
                        today.setHours(0, 0, 0, 0);

                        this.applications = _.orderBy(result, ["scholasticPeriodStartDate", "dateCreated"], ["desc", "desc"]);

                        _.forEach(this.applications, (f: any) => {
                            f.statusId = this.getApplicationStatus(f);
                            f.isOpenForAdmissions = this.allScholasticPeriods.find(a => f.programId ? a.programId && a.programId === f.programId : a.scholasticPeriodId && a.scholasticPeriodId === f.scholasticPeriodId).isOpenForAdmissions;

                            if (f.isCancelled)
                                f.applicationStatus = "Cancelled Before Completion";
                            else {
                                if (f.notificationDate && new Date(f.notificationDate) > today && (f.admissionsApplicationRegistrationStatusDescription.indexOf("Accept") !== -1 || f.admissionsApplicationRegistrationStatusDescription.indexOf("Reject") !== -1)) {
                                    f.applicationStatus = "Pending";
                                } else {
                                    if (f.admissionsApplicationStatusId === 6 || f.admissionsApplicationStatusId === 9 || f.admissionsApplicationStatusId === 12 || f.admissionsApplicationStatusId === 29 ||
                                        f.admissionsApplicationStatusId === 36 ||
                                        f.admissionsApplicationStatusId === 40 ||
                                        f.admissionsApplicationStatusId === 14 ||
                                        f.admissionsApplicationStatusId === 30 ||
                                        f.admissionsApplicationStatusId === 4 ||
                                        f.admissionsApplicationStatusId === 5)
                                        f.applicationStatus = f.admissionsApplicationStatusDescription;
                                    else
                                        f.applicationStatus = f.admissionsApplicationRegistrationStatusDescription;
                                }
                            }
                        });

                        //remove the missing documents notification if no missing documents are found
                        var missingApplicationDocuments = this.applications.filter(f => f.numRequiredDocuments > 0 && (f.admissionsApplicationRegistrationStatusId === 6 || f.admissionsApplicationRegistrationStatusId === 7 || f.admissionsApplicationRegistrationStatusId === 16));

                        if (!missingApplicationDocuments || missingApplicationDocuments.length === 0) {
                            _.remove(this.currentUser.userNotifications,
                                f => f.code === "admissionsApplicationDocuments");

                            this.storageService.store(this.appGlobals.localStorageKeys.currentUser, this.currentUser);
                        }
                    });
        }
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.currentUserSubscription.unsubscribe();
        this.mediaWatcherSubscription.unsubscribe();
    }

    insertOrUpdateApplication(allowEdit: boolean, applicationId?: number, selectedStepIndex?: number) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = "90%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "popup-dialog-container";

        const existingApplicationScholasticPeriods = [];

        _.forEach(this.applications, (f: any) => {
            const scholasticPeriod = {
                scholasticPeriodId: f.scholasticPeriodId,
                programId: f.programId
            };

            existingApplicationScholasticPeriods.push(scholasticPeriod);
        });

        dialogConfig.data = {
            currentUser: this.currentUser,
            applicationId: applicationId ? applicationId : 0,
            selectedStepIndex: selectedStepIndex ? selectedStepIndex : 0,
            existingApplicationScholasticPeriods: existingApplicationScholasticPeriods,
            allowEdit: allowEdit
        };

        const dialogRef = this.dialog.open(AdmissionsApplicationDialogComponent, dialogConfig);

        if (allowEdit) {
            dialogRef.afterClosed().subscribe(() => {
                setTimeout(() => {
                    this.getApplications();
                }, 0);
            });
        }
    }

    applicationDocuments(applicationId: number, scholasticPeriod: string, funnelId: number, funnel: string) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = "90%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "popup-dialog-container";

        dialogConfig.data = {
            applicationId: applicationId,
            scholasticPeriod: scholasticPeriod,
            funnelId: funnelId,
            funnel: funnel
        };

        const dialogRef = this.dialog.open(AdmissionsApplicationDocumentsDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(val => {
            if (val) {
                setTimeout(() => {
                    this.getApplications();
                }, 500);
            }
        });
    }

    getApplicationStatus(application: any) {
        let statusId = 0;

        if (application.dateCompleted) {
            //accepted
            if (application.admissionsApplicationStatusId !== 9 && application.admissionsApplicationStatusId !== 12 && application.admissionsApplicationStatusId !== 29
                && application.admissionsApplicationStatusId !== 8 && application.admissionsApplicationStatusId !== 6 && application.admissionsApplicationStatusId !== 36
                && application.admissionsApplicationStatusId !== 40 && application.admissionsApplicationStatusId !== 14 && application.admissionsApplicationStatusId !== 30
                && application.admissionsApplicationStatusId !== 4 && application.admissionsApplicationStatusId !== 5 && this.currentUser.studentCode)
                statusId = 1;
            else {
                //pending
                if (application.admissionsApplicationStatusId === 8 /*|| !this.currentUser.studentCode*/)
                    statusId = 2;
                else {
                    //deferred
                    if (application.admissionsApplicationStatusId === 12)
                        statusId = 3;
                    else {
                        //cancelled
                        if (application.admissionsApplicationStatusId === 6 ||
                            application.admissionsApplicationStatusId === 9 ||
                            application.admissionsApplicationStatusId === 29 ||
                            application.admissionsApplicationStatusId === 36 ||
                            application.admissionsApplicationStatusId === 40 ||
                            application.admissionsApplicationStatusId === 14 ||
                            application.admissionsApplicationStatusId === 30 ||
                            application.admissionsApplicationStatusId === 4 ||
                            application.admissionsApplicationStatusId === 5)
                            statusId = 4;
                    }
                }
            }
        } else {
            if (application.isCancelled)
                statusId = 4;
        }

        return statusId;
    }

    printApplication(admissionsApplicationId: number) {
        this.admissionsService.getAdmissionsApplicationPdf(admissionsApplicationId)
            .pipe(first())
            .subscribe((response) => {
                const file = new Blob([response], { type: "application/pdf" });
                var fileUrl = URL.createObjectURL(file);
                window.open(fileUrl);
            });
    }

    updateHousingRequirement(admissionsApplicationId: number, hasHousingApplication: boolean, rowversion: any, scholasticPeriodDescription: string, dateCompleted?: any) {
        if (hasHousingApplication || !dateCompleted) {
            return;
        }

        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = "25%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "confirmation-dialog-container";
        dialogConfig.data =
        {
            title: "Update Housing Requirement",
            content: `Your Housing Requirement for ${scholasticPeriodDescription} will be updated.`,
            rejectedReason: null,
            required: false,
            showSendRejectedEmail: false,
            rejectedEmailText: null
        };

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result === "confirm") {
                const saveModel = {
                    applicationId: admissionsApplicationId,
                    rowversion: rowversion
                }

                this.admissionsService.updateHousingRequirement(saveModel)
                    .pipe(first())
                    .subscribe(() => {
                        this.alertService.showMessage("Housing Requirement Successfully Updated.", "Admissions Application", this.appGlobals.alertMessageTypes.success);

                        setTimeout(() => {
                            this.getApplications();
                        }, 500);
                    });
            }
        });
    }

    pendingApplicationExists() {
        let app = _.find(this.applications, f => {
            return f.admissionsApplicationStatusId === 8 && f.isOpenForAdmissions;
        });

        return app !== null && app !== undefined;
    }
}
